module.exports = __webpack_public_path__ + "static/media/CF.037865b5.svg";